// NOTE: These named exports are the default "seed" content.
// At runtime the site reads content via useSite() which merges this
// with whatever is stored in MongoDB (edited via /admin).

// Mock data for Daniel Flynn's portfolio
// Sourced from danielflynn.squarespace.com + CV (DF_CV_26) + researched links

export const profile = {
  name: "Daniel Flynn",
  firstName: "Daniel",
  lastName: "Flynn",
  title: "Creative Director — Cinematic Content & AI Production",
  tagline: "Cinematic storytelling, powered by AI. Dublin-based.",
  location: "Dublin, IE",
  origin: "Dublin, IE",
  intro:
    "Creative and strategic content leader with 10+ years of international experience. I direct cinematic content and build AI-native production systems that automate the slow parts — so the craft can move faster without losing its edge.",
  longBio: [
    "I turn stories into systems. Over the last decade I've built and run content studios across Dublin, London and Amsterdam — from scrappy agency shoots to flagship livestream events and NFT campaigns that generated $1.3M in 24 hours.",
    "My practice sits at the intersection of cinematic storytelling and applied AI. I fine-tune LLMs on brand voice, rebuild pre-production pipelines with generative tools, and advise companies on EU AI Act compliance — without losing the craft that made the work worth watching in the first place.",
    "Based back in Dublin, currently helping founders, studios and consultancies ship ambitious content faster, leaner and smarter."
  ],
  email: "danielmartinflynn@gmail.com",
  phone: "+353 87 6234 742",
  cvUrl:
    "https://customer-assets.emergentagent.com/job_e21aacfb-a2fd-49f2-b8cd-617f00882b66/artifacts/tzkerj43_DF_CV_26%20%281%29.pdf",
  socials: {
    linkedin: "https://linkedin.com/in/daniel-flynn-163265bg",
    website: "https://danielflynn.squarespace.com/",
    youtube: "https://www.youtube.com/@Based-AF",
    calendly: "https://calendly.com/danielmartinflynn/new-meeting"
  },
  stats: [
    { value: "10+", label: "Years producing" },
    { value: "$1.3M", label: "NFT campaign / 24h" },
    { value: "14+", label: "Direct reports" },
    { value: "50%", label: "Pre-prod time cut w/ AI" }
  ]
};

// Featured hero showreel
export const heroReel = {
  provider: "youtube",
  youtubeId: "3CyDYZTeErw",
  title: "Featured Trailer",
  client: "Selected work",
  role: "Creative Director · Producer"
};

// Headcase showreel scraped from Squarespace source (vimeo ID confirmed from HTML)
export const HEADCASE_SHOWREEL = {
  id: "204657292",
  provider: "vimeo",
  title: "Headcase TV — Showreel Edit (2017)"
};

// Client logos for the About section marquee
export const clientLogos = [
  "Ledger",
  "Volvo",
  "bunq",
  "art'otel",
  "PPHE",
  "The Defiant",
  "Based-AF",
  "FansBet",
  "Beatyard",
  "Eatyard",
  "AI & Partners"
];

export const projects = [
  {
    slug: "based-af",
    title: "Based-AF",
    year: "2022 — 2024",
    role: "Co-founder · COO · Lead Producer",
    client: "Based-AF (YouTube)",
    categories: ["Web3", "YouTube", "AI Production"],
    cover:
      "https://images.squarespace-cdn.com/content/v1/5fa2cf377327893bd886b39b/1726570454127-S7D4WCGJAUAXDYAU30LR/Screenshot+2024-09-17+at+12.53.45.png",
    summary:
      "A start-up venture with a single goal: to become the MTV of the Metaverse. We built a real-time motion-capture studio for rapid 3D animation and scaled to 5+ long-form pieces, 20+ viral clips and a weekly livestream — including a full recreation of MKBHD's studio inside Fortnite using UEFN.",
    impact: [
      "$1.3M revenue in 24h via flagship NFT campaign",
      "AI integration (ChatGPT / Runway / Descript) cut pre-prod 50% and cost 60%",
      "Directly managed a 14-person cross-functional team"
    ],
    pullQuote: "The MTV of the Metaverse.",
    links: [
      { label: "Based-AF on YouTube (17K subs)", href: "https://www.youtube.com/@Based-AF" },
      { label: "Based-AF Fortnite creator page", href: "https://www.fortnite.com/@based-af" }
    ],
    videos: [
      { id: "nMTTY4OdQHA", provider: "youtube", title: "The world's strangest ultra-marathon" },
      { id: "Fc2gAB0_U0k", provider: "youtube", title: "We Put MKBHD in Fortnite!" },
      { id: "WU5YLFt1BSo", provider: "youtube", title: "Black Mirror Enters the Metaverse" },
      { id: "pISToS8QW9g", provider: "youtube", title: "How The Metaverse DESTROYED My Marriage" }
    ]
  },
  {
    slug: "the-defiant",
    title: "The Defiant",
    year: "2021 — 2022",
    role: "Lead Producer",
    client: "The Defiant",
    categories: ["DeFi", "News", "YouTube"],
    cover:
      "https://images.squarespace-cdn.com/content/v1/5fa2cf377327893bd886b39b/1635591501852-03H5JGY321UMLMAADN77/Screenshot+2021-10-30+at+12.57.12.jpg",
    summary:
      "One of the fastest-growing channels in the crypto space. A daily DeFi news and entertainment outlet where I ran the full video operation — prep, talent, roles, delivery — and architected its first AI-powered scripting workflow. Sponsored editorially by Ledger — one of just two partnerships the brand has ever taken on.",
    impact: [
      "Grew the channel past 131K subscribers and 1M+ cumulative video views during my tenure",
      "+30% partnership revenue in Q1–Q2 2021 via top-tier sponsors (Ledger and others)",
      "Fine-tuned an LLM on the script corpus to standardise brand Tone of Voice",
      "Oversaw the entire production lifecycle across a growing weekly slate"
    ],
    links: [
      { label: "The Defiant on YouTube (131K subs)", href: "https://www.youtube.com/c/thedefiant" },
      { label: "thedefiant.io", href: "https://thedefiant.io" }
    ],
    videos: [
      { id: "0G4h9IfnVzU", provider: "youtube", title: "The Defiant Guide to Pak — Part I" },
      { id: "cY9lM73ie0Q", provider: "youtube", title: "The Greatest NFT Film Ever Made" },
      { id: "6-r60S8by9A", provider: "youtube", title: "12 months of crazy: the best of The Defiant Weekly" },
      { id: "-42nnj01FxA", provider: "youtube", title: "Liquidators: The Silent Killers of DeFi" }
    ]
  },
  {
    slug: "school-of-block",
    title: "School of Block",
    year: "2021",
    role: "End-to-end Producer",
    client: "Ledger × The Defiant",
    categories: ["Education", "Crypto", "Series"],
    cover:
      "https://images.squarespace-cdn.com/content/v1/5fa2cf377327893bd886b39b/1642601915021-9YHRN7W1UOR7KE9CLKGH/Facebook+International+social+image+1.jpg",
    summary:
      "Co-produced by Ledger and The Defiant, launched 3 March 2021. A 42-episode weekly news-and-entertainment series built to pull new eyeballs into crypto. I ran each episode end-to-end, from script to delivery, balancing education with entertainment.",
    impact: [
      "42 episodes, weekly delivery from script → shoot → post under tight timelines",
      "Format designed to convert crypto-curious viewers into informed users",
      "Episodes hosted on both YouTube and Ledger Academy for long-tail discovery"
    ],
    links: [
      { label: "School of Block — Ledger Academy hub", href: "https://www.ledger.com/academy/series/school-of-block" },
      {
        label: "Full playlist (42 episodes) on YouTube",
        href: "https://www.youtube.com/playlist?list=PL6VM0N695IhnurbIjBTwzQ3cSeXvBJeJj"
      }
    ],
    videos: [
      { id: "tQEkdu6zT_A", provider: "youtube", title: "Cryptocurrency (i.e. Bitcoin) explained" },
      { id: "wYB0FncHZ_M", provider: "youtube", title: "The full scoop — what is money, really?" },
      { id: "EsxUw72auZc", provider: "youtube", title: "Introducing School of Block" },
      { id: "QHcIYt-QNd0", provider: "youtube", title: "Why is Bitcoin so hot — how it works, explained for all" }
    ]
  },
  {
    slug: "bunq-updates",
    title: "bunq Updates: Live Events",
    year: "2019 — 2021",
    role: "Producer · DOP · Editor · Media Manager",
    client: "bunq",
    categories: ["Fintech", "Live Events", "Brand"],
    cover:
      "https://images.squarespace-cdn.com/content/v1/5fa2cf377327893bd886b39b/0ccc0a7d-4e09-479a-a248-8f5db3048f79/bunq-sms-valiederen.jpg",
    summary:
      "bunq's flagship Update events — held three times a year at Amsterdam theatres — are the cornerstone of a bunq year, where every new feature is demoed live and streamed worldwide. Across Updates 13–16 (2019–2021) I created and ran all on-screen media for running order and VT.",
    impact: [
      "Streamlined review process, cutting content turnaround by 40%",
      "Modular, localisable video assets for global product launches",
      "On-screen running-order + VT format I built is still used at Update events today"
    ],
    videos: [
      { id: "jrU9WJNi5Zs", provider: "youtube", title: "What's new in bunq Update 13" },
      { id: "2yyWQoFTncc", provider: "youtube", title: "What's new in bunq Update 14" },
      { id: "v69amNBsBxI", provider: "youtube", title: "What is new in bunq Update 15" },
      { id: "rmbVLc3FBUE", provider: "youtube", title: "bunq Update 16" }
    ]
  },
  {
    slug: "artotel",
    title: "art'otel",
    year: "2018 — 2019",
    role: "Producer · DOP · Logistics · Post Supervisor",
    client: "PPHE / art'otel",
    categories: ["Hospitality", "Brand", "In-house"],
    cover:
      "https://images.squarespace-cdn.com/content/v1/5fa2cf377327893bd886b39b/1604570067122-A0V3WKMDFL1ED3KKKPUX/56828211_2431584166852017_3048496056451989504_o.jpg",
    summary:
      "Bringing production in-house for PPHE across the art'otel hotel portfolio — most notably the Pink Ribbon Live Paint, in partnership with Breast Cancer Care and Syrian refugee artist Marwa Mezher — an expressive piece titled 'The Hope…' — alongside a promo film for art'otel Berlin Mitte.",
    impact: [
      "Pink Ribbon Live Paint w/ Marwa Mezher — charity collaboration for Breast Cancer Care",
      "End-to-end production across multiple European markets",
      "+25% video engagement via a new social analytics workflow"
    ],
    videos: []
  },
  {
    slug: "volvo-lifepaint",
    title: "Volvo Lifepaint",
    year: "2016",
    role: "Producer · Scriptwriter · Post Producer",
    client: "Volvo × Grey London",
    categories: ["Automotive", "Campaign", "Documentary"],
    cover:
      "https://images.squarespace-cdn.com/content/v1/5fa2cf377327893bd886b39b/1604509019422-A34NESTQYTD49J6PUJBQ/Screenshot+2020-11-04+at+17.55.54.png",
    summary:
      "Built around Volvo's 2020 vision of zero annual road deaths, this piece mapped the journey toward safer streets in Dublin through interviews with drivers, cyclists and city council — framing the product as a partner, not a silver bullet.",
    impact: [
      "Part of the wider Life Paint campaign that won two Grand Prix at Cannes Lions 2015 (Promotion & Activation + Design) — the only campaign to take the double that year",
      "Campaign drove 130M+ Twitter impressions across 156 countries in 20 days",
      "Interview-led narrative built trust across three stakeholder groups"
    ],
    links: [
      { label: "D&AD Awards archive — Life Paint", href: "https://www.dandad.org/work/d-ad-awards-archive/lifepaint" },
      {
        label: "Campaign Live — 'Cannes winners remembered: Life Paint'",
        href: "https://www.campaignlive.co.uk/article/day-13-cannes-winners-remembered-volvo-life-paint/1396914"
      },
      {
        label: "The Drum — Cannes Grand Prix coverage",
        href: "https://www.thedrum.com/news/volvo-s-grand-prix-winning-lifepaint-campaign-fuels-its-dash-brand-purpose"
      },
      { label: "Grey London — original case page", href: "https://www.campaignlive.com/article/volvo-life-paint-grey-london/1340709" }
    ],
    videos: [
      { id: "191699490", h: "4efc60733d", provider: "vimeo", title: "Volvo Lifepaint — Dublin" },
      HEADCASE_SHOWREEL
    ]
  },
  {
    slug: "fansbet",
    title: "FansBet",
    year: "2016",
    role: "Client Lead · Producer · On-site Director",
    client: "FansBet",
    categories: ["Sports", "Brand", "Documentary"],
    cover:
      "https://images.squarespace-cdn.com/content/v1/5fa2cf377327893bd886b39b/1604512613792-CCDNLOR8MA89USF00QT4/Screenshot+2020-11-04+at+18.56.11.png",
    summary:
      "FansBet is the only UK bookmaker giving 50% of net profits to fans' chosen grassroots clubs. We told the story through the eyes of lifelong supporters — what their clubs mean to them, and how modern football has changed the game.",
    impact: [
      "Authentic supporter-led narrative aligned with the brand's ethos",
      "Multi-location UK shoot delivered on a tight agency timeline"
    ],
    videos: [
      { id: "205851346", h: "c396da0861", provider: "vimeo", title: "FansBet — The Loyal Fan" },
      HEADCASE_SHOWREEL
    ]
  },
  {
    slug: "beatyard",
    title: "Beatyard Festival",
    year: "2015 — 2017",
    role: "Head of Content Production",
    client: "Beatyard · Bodytonic",
    categories: ["Festival", "Music", "Live"],
    cover:
      "https://images.squarespace-cdn.com/content/v1/5fa2cf377327893bd886b39b/1604508584713-CX5R8169TMHA28QD1PSB/20626198_1441164315972125_6001289542212427289_o.jpg",
    summary:
      "Two years leading content for Dublin's Beatyard at Dún Laoghaire Harbour — Bodytonic-produced, headlined by Orbital, St Germain, George Clinton and Daniel Wang. I rolled out photography and video across the weekend: Day 1 highlights, live performances and full recap edits.",
    impact: [
      "Staff + client liaison, on-site directing and post supervision in parallel",
      "Recap edits turned around for same-weekend social delivery",
      "Lineup included Orbital · St Germain · George Clinton · Daniel Wang"
    ],
    links: [
      {
        label: "Hot Press — 'Funk, food and fun aplenty at The Beatyard'",
        href: "https://www.hotpress.com/music/funk-food-and-fun-aplenty-at-the-beatyard-17934232"
      },
      {
        label: "Irish Times — 'Music, food and games by the sea'",
        href: "https://www.irishtimes.com/life-and-style/food-and-drink/select-music-food-and-games-by-the-sea-at-dun-laoghaire-s-the-beatyard-festival-1.2301936"
      },
      { label: "Bodytonic festivals page", href: "https://bodytonicmusic.com/festivals/" }
    ],
    videos: [
      { id: "ZyGaj4dfOcw", provider: "youtube", title: "Beatyard 2016 — Festival Recap" },
      HEADCASE_SHOWREEL
    ]
  },
  {
    slug: "eatyard",
    title: "Eatyard",
    year: "2017",
    role: "Lead Producer · Director · Editor",
    client: "Eatyard · Bodytonic",
    categories: ["Food", "Brand", "Social"],
    cover:
      "https://images.squarespace-cdn.com/content/v1/5fa2cf377327893bd886b39b/1604652041153-76A8OAP5QAXUGY8KED75/Screenshot+2020-11-06+at+09.34.16.png",
    summary:
      "Eatyard started as a pop-up street-food spin-off of Beatyard. The brief: sell three moods at once — family vibes by day, social energy at night, and a mouth-watering menu. The project has since grown into Dublin's now-permanent outdoor food market in Phibsboro, still running today.",
    impact: [
      "Three-in-one visual narrative across daytime, nightlife and food",
      "Lean in-house delivery from lead producer through edit suite",
      "Original pop-up format evolved into a permanent Dublin institution"
    ],
    links: [
      { label: "the-eatyard.com (still running)", href: "https://the-eatyard.com" },
      {
        label: "Lovin Dublin — '10 food stalls to check out'",
        href: "https://www.lovindublin.com/sponsored/10-food-stalls-to-check-out-at-beatyard-weekend"
      }
    ],
    videos: [
      { id: "195848961", h: "a96823a680", provider: "vimeo", title: "Eatyard — Pop-up Street Food" },
      HEADCASE_SHOWREEL
    ]
  }
];

export const experience = [
  {
    company: "AI & Partners",
    role: "Sales & Branding Director",
    location: "Amsterdam, NL",
    period: "Dec 2024 — Sept 2025",
    teamSize: "Consulting",
    bullets: [
      "Led content strategy for an AI-governance consultancy; built a 12-module e-learning course on EU AI Act compliance for client onboarding & certification.",
      "Drove B2B brand-building through LinkedIn thought leadership on ethical AI integration."
    ]
  },
  {
    company: "Based-AF",
    role: "COO & Lead Producer (Co-founder)",
    location: "Voorschoten, NL",
    period: "Jun 2022 — Jul 2024",
    teamSize: "14 direct reports",
    bullets: [
      "Co-founded and scaled the studio to 5+ long-form videos, 20+ viral clips and a weekly livestream.",
      "Led AI integration (ChatGPT / Runway / Descript), cutting pre-prod time 50% and cost 60%.",
      "Produced a flagship NFT campaign generating $1.3M in 24 hours.",
      "Directly managed 14 creatives, producers and engineers."
    ]
  },
  {
    company: "The Defiant",
    role: "Lead Producer",
    location: "Voorschoten, NL",
    period: "Mar 2021 — Jun 2022",
    teamSize: "Lead of video ops",
    bullets: [
      "Lifted partnership revenue +30% in Q1–Q2 2021 via sponsored content with top-tier clients (Ledger and others).",
      "Architected the company's first AI workflow by fine-tuning an LLM on a script corpus to standardise brand Tone of Voice.",
      "Owned the full production lifecycle for a leading Web3 news outlet."
    ]
  },
  {
    company: "bunq",
    role: "Content Producer",
    location: "Amsterdam, NL",
    period: "Sep 2019 — Mar 2021",
    teamSize: "In-house producer",
    bullets: [
      "Cut content turnaround 40% by streamlining review and building modular, localisable video assets.",
      "Produced SEO-driven video supporting major acquisition pushes and product feature launches."
    ]
  },
  {
    company: "Park Plaza Hotels Europe (PPHE)",
    role: "Content Executive",
    location: "Amsterdam, NL",
    period: "Jun 2018 — Jun 2019",
    teamSize: "In-house content exec",
    bullets: [
      "Led end-to-end production of marketing and branded hotel content across European markets.",
      "Built cross-platform visual assets for internal comms and social.",
      "Launched analytics tracking that grew video engagement +25%."
    ]
  },
  {
    company: "Headcase Marketing",
    role: "Head of Content",
    location: "Dublin, IE",
    period: "May 2015 — Oct 2017",
    teamSize: "Agency content lead",
    bullets: [
      "Directed content and campaigns for lifestyle, sports and retail brands in a high-volume agency environment.",
      "Owned budgeting, scheduling and client relations.",
      "Delivered 50+ projects end-to-end, often on tight deadlines."
    ]
  }
];

// C2 — tooling grid (first-letter monograms; coloured per brand)
export const aiTools = [
  { name: "ChatGPT", letter: "G", color: "bg-emerald-500/15 text-emerald-300 border-emerald-400/25" },
  { name: "MidJourney", letter: "M", color: "bg-violet-500/15 text-violet-300 border-violet-400/25" },
  { name: "Runway", letter: "R", color: "bg-sky-500/15 text-sky-300 border-sky-400/25" },
  { name: "Descript", letter: "D", color: "bg-amber-500/15 text-amber-300 border-amber-400/25" },
  { name: "Firefly", letter: "F", color: "bg-rose-500/15 text-rose-300 border-rose-400/25" },
  { name: "Custom LLMs", letter: "L", color: "bg-lime-500/15 text-lime-300 border-lime-400/25" }
];

// C3 — certifications / credentials row
export const certifications = [
  {
    title: "EU AI Act compliance course",
    org: "12-module e-learning, author & instructor — AI & Partners (2025)"
  },
  {
    title: "ISO 42001 aware",
    org: "AI Management Systems — pre-audit readiness"
  },
  {
    title: "Adobe Creative Suite",
    org: "Premiere Pro · After Effects · Photoshop · Lightroom (10+ yrs)"
  },
  {
    title: "BA Journalism & Visual Media",
    org: "Griffith College Dublin — Distinction (2015)"
  }
];

// C1 — EU AI Act milestones
export const aiActTimeline = [
  { date: "Aug 2024", label: "Regulation in force" },
  { date: "Feb 2025", label: "Prohibited-practice ban" },
  { date: "Aug 2025", label: "GPAI obligations" },
  { date: "Aug 2026", label: "High-risk systems — full conformity" }
];

export const skills = {
  "AI & Automation": [
    "Generative AI (ChatGPT, MidJourney, Runway, Descript, Firefly)",
    "LLM Fine-Tuning",
    "AI Governance (EU AI Act)",
    "Workflow Automation"
  ],
  "Monetization & Strategy": [
    "Sponsored Content",
    "Subscription Models",
    "NFT Campaigns",
    "SEO / Content Optimisation",
    "Creative Ideation"
  ],
  "Production & Leadership": [
    "Cross-Platform Production",
    "Scriptwriting & Storyboarding",
    "Team Management (14+)",
    "Budgeting & Scheduling",
    "Adobe Creative Suite"
  ]
};

export const education = [
  {
    school: "Griffith College Dublin",
    degree: "BA Journalism & Visual Media",
    period: "2012 — 2015",
    note: "Distinction for radio documentary: \"Homosexuality in Sports and the Stigma Surrounding Masculinity.\""
  }
];

export const nav = [
  { id: "work", label: "Work" },
  { id: "about", label: "About" },
  { id: "experience", label: "Experience" },
  { id: "skills", label: "Capabilities" },
  { id: "contact", label: "Contact" }
];

// Default content bundle used by SiteContext as the seed
export const DEFAULT_CONTENT = {
  profile,
  heroReel,
  HEADCASE_SHOWREEL,
  clientLogos,
  projects,
  experience,
  aiTools,
  certifications,
  aiActTimeline,
  skills,
  education,
  nav
};
